import { Trans, useLingui } from "@lingui/react/macro";
import { FilledButton, OutlinedButton } from "@medoma/components/Button/Button";
import { Text } from "@medoma/components/Text/Text";
import { knownFeatureFlagsSchema, useFeatureFlag } from "@/api/FeatureFlags";
import styles from "./ProspectActions.module.scss";

export const ProspectActions = () => {
  const { t } = useLingui();
  const { data: isAdmitPatientInGoEnabled } = useFeatureFlag(
    knownFeatureFlagsSchema.enum.FE_AdmitPatientInGo,
  );
  const { data: isDeclinePatientInGoEnabled } = useFeatureFlag(
    knownFeatureFlagsSchema.enum.FE_DeclinePatientInGo,
  );

  if (!isAdmitPatientInGoEnabled && !isDeclinePatientInGoEnabled) {
    return null;
  }

  return (
    <section className={styles.prospectActions} aria-label={t`Bedömning`}>
      <Text element="p">
        <Trans>Patienten är under bedömning</Trans>
      </Text>
      <div className={styles.buttons}>
        {isAdmitPatientInGoEnabled ? (
          <FilledButton asLinkTo="admit">
            <Trans>Fullfölj inskrivning</Trans>
          </FilledButton>
        ) : null}
        {isDeclinePatientInGoEnabled ? (
          <OutlinedButton asLinkTo="decline">
            <Trans>Avslå</Trans>
          </OutlinedButton>
        ) : null}
      </div>
    </section>
  );
};
